export const DEFAULT_TARGETING_JSON_ERROR = 'Default targeting must be valid JSON';

const isBlank = (value: unknown) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim().length === 0);

export const formatDefaultTargetingForInput = (value: unknown): string => {
  if (isBlank(value)) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  return JSON.stringify(value, null, 2);
};

export const parseDefaultTargetingInput = (value: unknown): unknown => {
  if (isBlank(value)) {
    return null;
  }

  if (typeof value !== 'string') {
    return value;
  }

  return JSON.parse(value);
};

export const validateDefaultTargetingJson = (value: unknown) => {
  if (isBlank(value)) {
    return undefined;
  }

  try {
    parseDefaultTargetingInput(value);
    return undefined;
  } catch {
    return DEFAULT_TARGETING_JSON_ERROR;
  }
};

export const parseDefaultTargetingText = (value: unknown): unknown => value;

type ProductFormData = {
  archivedAt?: string | null;
  defaultTargeting?: unknown;
  externalPioId?: string | null;
  name?: string;
};

export const transformProductInput = (data: ProductFormData) => {
  const transformed: ProductFormData = {
    name: data.name,
    externalPioId: isBlank(data.externalPioId) ? null : data.externalPioId,
    defaultTargeting: parseDefaultTargetingInput(data.defaultTargeting),
  };

  if ('archivedAt' in data) {
    transformed.archivedAt = data.archivedAt ?? null;
  }

  return transformed;
};
